import React from "react";
import "./Template_3.css";

const Template_3_AboutUs = () => {
  return (
    <section id="about" className="Template_3 section">
      <div className="Template_3 container">
        <div className="Template_3 section-title">
          <h2>About Us</h2>
          <p>Discover our journey and unique approach to travel</p>
        </div>
        <div className="Template_3 about-content">
          <div className="Template_3 about-image">
            <img
              src="https://images.unsplash.com/photo-1521336575822-6a8f6415d9e7?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
              alt="Our Team"
            />
          </div>
          <div className="Template_3 about-text">
            <h3>Premier Travel Experiences</h3>
            <p>
              Founded in 2008, WanderLux aims to provide premium travel
              solutions for discerning clients. We've curated exceptional
              journeys for over a decade.
            </p>
            <p>
              Our dedicated specialists design bespoke itineraries, focusing on
              luxury and authenticity. From exclusive retreats to cultural
              immersions, we cater to refined tastes.
            </p>
            <div className="Template_3 about-stats">
              <div className="Template_3 stat">
                <div className="Template_3 stat-number">15+</div>
                <div className="Template_3 stat-label">Years of Excellence</div>
              </div>
              <div className="Template_3 stat">
                <div className="Template_3 stat-number">100+</div>
                <div className="Template_3 stat-label">
                  Premium Destinations
                </div>
              </div>
              <div className="Template_3 stat">
                <div className="Template_3 stat-number">20k+</div>
                <div className="Template_3 stat-label">Satisfied Clients</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Template_3_AboutUs;
